var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.1666H12.0075",
    stroke: "#8F9BBA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 9.08337V13.25C18.6668 16.3927 18.6668 17.9641 17.6905 18.9404C16.7142 19.9167 15.1428 19.9167 12.0002 19.9167C8.85746 19.9167 7.28612 19.9167 6.3098 18.9404C5.3335 17.9641 5.3335 16.3927 5.3335 13.25V9.08337",
    stroke: "#8F9BBA",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3332 10.75L16.7139 7.27961C14.4917 5.14878 13.3806 4.08337 11.9998 4.08337C10.6191 4.08337 9.50801 5.14878 7.2858 7.27961L3.6665 10.75",
    stroke: "#8F9BBA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome2);
export default __webpack_public_path__ + "static/media/ic-Home2.a1a40c0688558a56ed85f3980fba5a44.svg";
export { ForwardRef as ReactComponent };